import { render } from "./EmployeesPage.vue?vue&type=template&id=787addb8"
import script from "./EmployeesPage.vue?vue&type=script&lang=ts"
export * from "./EmployeesPage.vue?vue&type=script&lang=ts"
script.render = render

export default script